<nav id="sidebar" [ngClass]="{ active: sidebarService.active, 'toggle-sidebar': sidebarService.minSidebar, 'px-2': !sidebarService.minSidebar }">
	<div>
		<ul class="list-unstyled components">
			<li routerLinkActive="active" [ngClass]="{ 'dropdown-active': item.dropdown }"
				*ngFor="let item of itemsMenu">
				<a [ngClass]="{ 'justify-content-center': sidebarService.minSidebar }" *ngIf="item.type === 'link'"
					[routerLink]="[item.link]" routerLinkActive="active">
					<i class="fal {{ item.icon }}"></i>
					<span *ngIf="!sidebarService.minSidebar">{{ item.label }}</span>
				</a>
				<ng-container *ngIf="item.type === 'dropdown'">
					<a [ngClass]="{ 'justify-content-center': sidebarService.minSidebar }" data-toggle="collapse"
						(click)="setActiveMenu(item)" [attr.aria-expanded]="item.dropdown" class="dropdown-toggle">
						<i class="fal {{ item.icon }}"></i>
						<span *ngIf="!sidebarService.minSidebar">{{ item.label }}</span>
						<i *ngIf="!sidebarService.minSidebar" class="fal fa-angle-right icon-dropdown ms-auto"></i>
					</a>
					<ul class="collapse list-unstyled" id="{{ item.id }}"
						[ngClass]="{ show: item.dropdown, 'ml-0': sidebarService.minSidebar }">
						<li *ngFor="let children of item.children">
							<a *ngIf="!children.justAdmin || isAdmin"
								[ngClass]="{ 'justify-content-center': sidebarService.minSidebar }"
								[routerLink]="[children.link]" routerLinkActive="active">
								<span *ngIf="!sidebarService.minSidebar">{{ children.label }}</span>
								<span *ngIf="sidebarService.minSidebar">
									<i class="fal {{ children.icon || 'fa-chevron-circle-right' }} icon-min-sidebar"></i>
								</span>
							</a>
						</li>
					</ul>
				</ng-container>
			</li>
			<li *ngIf="canViewFloDashboard$ | async" routerLinkActive="active">
				<a [routerLink]="['/painel/admin/flo-dashboard']" routerLinkActive="active" [ngClass]="{ 'justify-content-center': sidebarService.minSidebar }" aria-label="DASHBOARD FLÔ">
					<i class="fal fa-chart-line" aria-hidden="true"></i>
					<span *ngIf="!sidebarService.minSidebar">DASHBOARD FLÔ</span>
				</a>
			</li>
		</ul>
		<ul class="list-unstyled components ul-toggle-sidebar" *ngIf="isMobile">
			<li *ngIf="!sidebarService.minSidebar">
				<a (click)="toggleSidebar()" role="button"><i class="fal fa-angle-left"></i> Recolher menu </a>
			</li>
			<li *ngIf="sidebarService.minSidebar">
				<a (click)="toggleSidebar()" class="justify-content-center" role="button">
					<i class="fal fa-angle-right"></i>
				</a>
			</li>
		</ul>
		<ul class="list-unstyled components">
			<li *ngIf="!sidebarService.minSidebar">
				<a class="justify-content-center">
					<img src="../../../../../assets/images/logo-flowing.png" height="16">
				</a>
			</li>
		</ul>
		<ul class="list-unstyled components">
			<li *ngIf="sidebarService.minSidebar"></li>
		</ul>
	</div>
</nav>
